import { HeroContent } from '../types';

export const heroContent: HeroContent = {
  headline: 'Intelligent',
  highlightedText: 'Agentic Systems',
  description: 'AZ1.AI specializes in developing and deploying sophisticated agentic systems that transform how businesses operate. Our solutions combine AI agents with purpose-built frameworks for autonomous decision-making and execution.',
  primaryButtonText: 'Explore Solutions',
  secondaryButtonText: 'Schedule Consultation',
  primaryButtonLink: '#solutions',
  secondaryButtonLink: '#contact'
};